<template>
  <div id="formSanction">
    <Topbar @action="fnAction"></Topbar>
    <v-container class="center" v-if="loaded">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 class="item">
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-layout row wrap>
                <!-- <v-flex xs12 class="name">{{ $t( "basic_info" ) }}</v-flex> -->
                <div style="width:100%;height:auto;display:contents;">
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'titles.player' | i18n"
                      :value="
                        (sanction.person_name + ' ' + sanction.person_surname)
                          | checkParam
                      "
                      disabled
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <img :src="sanction.team_shield" />
                    <span class="label_image">{{
                      sanction.team_name + " (" + sanction.category_name + ")"
                    }}</span>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.match_name' | i18n"
                      :value="sanction.match_name | checkParam"
                      disabled
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item"> </v-flex>
                  <v-flex xs12 md12 class="item">
                    <v-text-field
                      :label="'params.type' | i18n"
                      :value="
                        (sanction.type +
                          ' ' +
                          $t(punishments[sanction.type].description))
                          | checkParam
                      "
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12 class="item">
                    <v-textarea
                      :label="'params.observations' | i18n"
                      :value="sanction.comment | checkParam"
                      @change="v => (sanction.comment = v)"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.num_matches' | i18n"
                      :value="sanction.num_match | checkParam"
                      @change="v => (sanction.num_match = v)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.num_matches_completed' | i18n"
                      :value="sanction.matches_completed | checkParam"
                      @change="v => (sanction.matches_completed = v)"
                    ></v-text-field>
                  </v-flex>
                </div>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Topbar from "@/components/ui/Topbar";

export default {
  name: "SanctionForm",
  components: { Topbar },
  props: { page: String, action: String },
  data() {
    return {
      sanction: false,
      valid: false,
      loaded: false
    };
  },
  computed: {
    punishments() {
      var punishments = this.$store.getters["competition/getPunishments"](
        this.$store.getters["events/getCurrentEvent"]().type_id
      );
      var oPunishments = {};
      punishments.forEach(punish => {
        oPunishments[punish.code] = punish;
      });

      return oPunishments;
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage"
  },
  created() {
    this.loadDataPage();
  },
  methods: {
    loadDataPage() {
      this.$store.commit("setTopbarActionsVisible", true);
      this.$store.commit("setMenuVisible", true);

      var id = this.$route.params.id;
      var self = this;
      if (id !== undefined && !this.loaded) {
        this.$overlay.loading();

        this.$store
          .dispatch("competition/sanctions/loadList", {
            event: this.$store.getters["events/getCurrentEvent"]().id
          })
          .then(function() {
            self.sanction = {
              ...self.$store.getters["competition/sanctions/getList"](id)
            };

            self.loaded = true;
            self.$overlay.hide();
          });
      } else {
        this.$overlay.hide();
      }
    },

    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "save":
          this.fnSave(emit.params);
          break;
        case "sanction_desestimar":
          this.fnDesestimar(emit.params);
          break;
        case "go_to_match_edit":
          this.fnGoToMatch(emit.params);
          break;
      }
    },

    fnDesestimar() {
      this.$overlay.loading();

      var self = this;
      this.$store
        .dispatch("competition/sanctions/desestimar", {
          id: this.sanction.id
        })
        .then(function() {
          self.$overlay.hide();
          var event = self.$store.getters["events/getCurrentEvent"]();
          self.$router.push({
            name: "event_competition_sanctions",
            params: {
              event: self.$root
                .formatEventUrl(event.name, event.edition)
                .replace("/event/", "")
            }
          });
        });
    },

    fnGoToMatch() {
      window.open(
        process.env.VUE_APP_APP_URL +
          "event/" +
          this.$route.params.event +
          "/competition/matchs/" +
          this.sanction.category_id +
          "/" +
          this.sanction.phase_id +
          "/" +
          this.sanction.match_id +
          "/edit",
        "_blank"
      );
    },

    fnSave() {
      if (this.$refs.form.validate()) {
        var uploadSanction = {
          comment: this.sanction.comment,
          num_match: this.sanction.num_match,
          matches_completed: this.sanction.matches_completed
        };

        var self = this;
        this.$store
          .dispatch("competition/sanctions/editSanction", {
            id: this.$route.params.id,
            event_id: this.$store.getters["events/getCurrentEvent"]().id,
            data: uploadSanction
          })
          .then(function() {
            var event = self.$store.getters["events/getCurrentEvent"]();
            self.$router.push({
              name: "event_competition_sanctions",
              params: {
                event: self.$root
                  .formatEventUrl(event.name, event.edition)
                  .replace("/event/", "")
              }
            });
          });
      } else {
        this.$popup.alert({
          message: i18n.t("exists_error_on_form"),
          btnSuccess: i18n.t("accept")
        });
      }
    },

    formatDate() {
      this.match.parsedDate = moment(this.match.date).format("DD/MM/YYYY");
    }
  },
  filters: {
    checkParam(value) {
      return value != null ? value : "";
    }
  },
  watch: {
    "match.name": {
      handler(val) {
        this.match.name = val;
      },
      deep: true
    },
    "match.referee_name": {
      handler(val) {
        this.match.referee_name = val;
      },
      deep: true
    },
    "match.referee_phone": {
      handler(val) {
        this.match.referee_phone = val;
      },
      deep: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#formSanction {
  width: 100%;
  display: inline-block;
  height: 100%;
  overflow-y: auto;

  .container {
    width: 80%;
    width: calc(100% - 350px);
    padding: 0px;

    &.center {
      margin: 0 auto;
    }

    .name {
      font-size: 22px;
      border-bottom: 2px solid;
      cursor: pointer;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      &.hidden {
        &::after {
          transform: rotate(180deg);
          transition-duration: 0.2s;
        }
      }
    }

    .clear {
    }

    .role {
      padding: 0;

      .container {
        margin: 0;
        width: 100%;

        .name {
          font-size: 18px;
          color: #685f5f;
        }
      }
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#acta {
        background-color: #ccc;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }

      .item.flex {
        padding: 0 20px;

        .image {
          // width: 40%;
          float: left;
          padding: 0 40px;

          img,
          .addthumb {
            width: 150px;
            border: 1px solid #ccc;
            height: 150px;
            position: relative;
            cursor: pointer;
          }

          .addthumb div {
            width: 100%;
            display: block;
            top: 35%;
            position: absolute;
            text-align: center;
          }
          .addthumb .text {
            top: 60%;
          }
        }

        .name {
          position: relative;

          .remove {
            width: fit-content;
            float: right;
          }

          .add {
            background-image: url(/img/add_b.svg);
            background-size: 15px;
            background-repeat: no-repeat;
            background-position: left center;
            position: absolute;
            right: 0;
            top: 15px;
            padding-left: 20px;
            text-transform: none;
            font-weight: bold;
            cursor: pointer;
          }
        }

        .v-input:not(.v-input--radio-group) .v-input__slot {
          border: none;
          border-bottom: 2px solid rgba(0, 0, 0, 0.14);
          border-radius: 0;
          padding-left: 0;
        }

        .v-image {
          width: 50px;
        }

        label {
          text-transform: capitalize;
        }
        .v-input__prepend-inner {
          margin-top: 25px;
        }

        .v-input.upper input {
          text-transform: uppercase;
        }
      }

      .v-menu__content {
        position: fixed !important;
      }
      .v-select {
        label {
          text-transform: capitalize;
          top: 0px;
          padding-left: 0;
          font-size: 18px;
          /*display: none;*/
        }
      }
    }

    img {
      width: 60px;
      max-width: 60px;
      line-height: 60px;
    }
    .label_image {
      line-height: 60px;
    }
  }
}
</style>
